<!-- Component to manage filtering of pods list -->
<template>
  <div class="filters">
    <b-field grouped position="is-left">
      <b-input
        expanded
        size="is-small"
        :placeholder="$t('PodFilters.input_search_placeholder')"
        v-model="localSearchPod"
        @keyup.native.enter="search"
      ></b-input>

      <p class="control">
        <button class="button is-primary is-small" @click="search()">
          <b-icon
            icon="magnify"
            size="is-small"
            :title="$t('PodFilters.search_tooltip')"
            @click="search()"
          ></b-icon>
        </button>
      </p>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'PodFilters',
  data: function () {
    return {
      localSearchPod: this.searchPod
    }
  },

  props: {
    searchPod: {
      type: String,
      required: false
    },

    planningId: {
      type: Number,
      required: false
    }
  },
  methods: {
    search () {
      const searchCriteria = this.localSearchPod.trim()
      if (searchCriteria) {
        this.$store.dispatch('planning/searchPods', [this.planningId, searchCriteria])
      } else {
        this.$store.dispatch('planning/retrieveAllPods', this.planningId)
      }
    }
  }
}
</script>
